// ======================================================================
// File Name       : GroupListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GroupSearch from '../../components/group/GroupSearch';
import GroupTreeContainer from './GroupTreeContainer';
import ModalConductor from '../../components/modal/ModalConductor';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import { BULK_EXPORT, MSG_DEL_GROUP } from '../../constants/MessageTemplate';
import DialogConfirm from '../../components/DialogConfirm';
import * as groupActions from '../../actions/GroupAction';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class GroupListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        groupName: '',
      },
      isAllowShowSearchMessage: false,
      resultList: [],
      showExportConfirm: false,
      showDelete: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.updateSearchResult = this.updateSearchResult.bind(this);
    this.onOkDelete = this.onOkDelete.bind(this);
    this.onOkExport = this.onOkExport.bind(this);
    this.handleExportBtn = this.handleExportBtn.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleInputChange(name, value) {
    const filterData = { ...this.state.filterData, ...{ [name]: value } };
    this.setState({
      filterData,
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false, resultList: [] });
  }

  updateSearchResult(isAllowShowSearchMessage, resultList) {
    this.setState({ isAllowShowSearchMessage, resultList });
  }

  onOkExport() {
    const { recordNumUserGroupRelationUserLoging } = this.props;
    const self = this;
    this.setState({
      showExportConfirm: false,
    }, () => {
      this.props.dispatch(groupActions.exportCSV());
    });
  }

  handleExportBtn() {
    this.setState({ showExportConfirm: true });
  }

  onOkDelete() {
    const { dispatch, recordNumUserGroupRelationUserLoging } = this.props;
    dispatch(groupActions.deleteGroup(this.state.groupSecernId));
    this.setState({ showDelete: false });
  }

  handleDelete(menuData, { callbackData = {} } = {}) {
    const { groupSecernId } = callbackData;
    this.setState({ showDelete: true, groupSecernId });
  }

  render() {
    const { filterData, resultList, isAllowShowSearchMessage } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={resultList && resultList.length ? resultList.length : 0}
          resultList={resultList}
          isAllowShowSearchMessage={isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="ユーザーグループ" />
        <GroupSearch
          filterData={filterData}
          onInputChange={this.handleInputChange}
          onPressEnter={this.handleSearchBtn}
        />
        <GroupTreeContainer
          filterData={filterData}
          ref={(groupTree) => {
            this.handleSearchBtn = groupTree && groupTree.getWrappedInstance().handleSearchBtn;
          }}
          updateSearchResult={this.updateSearchResult.bind(this)}
          handleExportBtn={this.handleExportBtn}
          handleDelete={this.handleDelete}
        />
        <DialogConfirm
          showModal={this.state.showDelete}
          onCancel={() => this.setState({ showDelete: false })}
          content={MSG_DEL_GROUP}
          onOK={this.onOkDelete}
          animation={false}
        />
        <DialogConfirm
          showModal={this.state.showExportConfirm}
          onCancel={() => this.setState({ showExportConfirm: false })}
          content={BULK_EXPORT}
          onOK={this.onOkExport}
          animation={false}
        />
        <ModalConductor />
      </div>
    );
  }
}

GroupListContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { recordNumUserGroupRelationUserLoging } = state.user;
  return { recordNumUserGroupRelationUserLoging };
};
export default connect(mapStateToProps)(GroupListContainer);
